/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Github_LabelInputs */

const en_hero_github_label = /** @type {(inputs: Hero_Github_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const ar_hero_github_label = /** @type {(inputs: Hero_Github_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const bn_hero_github_label = /** @type {(inputs: Hero_Github_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const de_hero_github_label = /** @type {(inputs: Hero_Github_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const es_hero_github_label = /** @type {(inputs: Hero_Github_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const fr_hero_github_label = /** @type {(inputs: Hero_Github_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const pt_hero_github_label = /** @type {(inputs: Hero_Github_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const zh_hero_github_label = /** @type {(inputs: Hero_Github_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const tr_hero_github_label = /** @type {(inputs: Hero_Github_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const ru_hero_github_label = /** @type {(inputs: Hero_Github_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const pl_hero_github_label = /** @type {(inputs: Hero_Github_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

/**
* | output |
* | --- |
* | "GitHub" |
*
* @param {Hero_Github_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const hero_github_label = /** @type {((inputs?: Hero_Github_LabelInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Github_LabelInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_hero_github_label(inputs)
	if (locale === "bn") return bn_hero_github_label(inputs)
	if (locale === "de") return de_hero_github_label(inputs)
	if (locale === "es") return es_hero_github_label(inputs)
	if (locale === "fr") return fr_hero_github_label(inputs)
	if (locale === "pt") return pt_hero_github_label(inputs)
	if (locale === "zh") return zh_hero_github_label(inputs)
	if (locale === "tr") return tr_hero_github_label(inputs)
	if (locale === "ru") return ru_hero_github_label(inputs)
	if (locale === "pl") return pl_hero_github_label(inputs)
	return en_hero_github_label(inputs)
});